import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector as useUntypedSelector } from 'react-redux';

import type { YammerTeamsEventState } from '../state/types';

export const useSelector: TypedUseSelectorHook<YammerTeamsEventState> = useUntypedSelector;
